var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BtnDropdown, ButtonBorderedKVBase, InputSearchBase, ModalUploadStudents, SwitchKvBase, TabHeader, Table } from '@/presentation/components';
import { IconTeacherBold } from '@/presentation/components/icons';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import { manageStudentsAtom } from './components/atoms';
import { addStudentsManuallyAtom } from './components/modal-add-students-manually/atoms';
import ModalAddStudentsManually from './components/modal-add-students-manually/modal-add-students-manually';
import ModalCheckout from './components/modal-checkout/modal-checkout';
import ModalClass from './components/modal-class';
import UseManageStudents from './hooks/use-manage-students';
import Styles from './manage-students-styles.scss';
import { debounce } from 'lodash';
import { CSVLink } from 'react-csv';
import { isSemiAnnual } from '@/presentation/functions/stripe-helper';
import ModalLimit from './components/modal-limit';
import { TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL } from '@/presentation/constants/stripe-constants';
import ModalCheckoutSuccess from './components/modal-checkout/modal-checkout-success';
import { SelectFilter } from '../manage-teachers/components';
import { PLANS } from '@/presentation/constants/plans';
import { uploadFromCsvStudentState } from '@/presentation/components/upload-from-file/students/atoms';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
const ManageStudents = ({ manageClasses, manageUsers, validationAddStudent, saveCsvFile, validationModalUploadTeachers, manageStripe, getUsersPaginated, getClasses, manageQuizzesUsers, managePreQuiz }) => {
    var _a, _b;
    const [state, setState] = useRecoilState(manageStudentsAtom);
    const [stateUpload, setStateUpload] = useRecoilState(uploadFromCsvStudentState);
    const [, setAddStudentsManuallyState] = useRecoilState(addStudentsManuallyAtom);
    const [showExportModal, setShowExportModal] = useState(false);
    const { showCustomError, showCustomSuccess, toastContainer } = useCustomToast();
    const { currentUserSession, getIdClient, user } = useUserSesssion();
    const idClient = getIdClient();
    const getClassList = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const response = yield manageClasses.getClassesByClientId(idClient);
        if (response)
            setState(prev => (Object.assign(Object.assign({}, prev), { classList: response, isLoading: false })));
    });
    const getTeachers = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const qb = RequestQueryBuilder.create();
        qb.setJoin({ field: 'client' });
        qb.setFilter({ field: 'userClient.id', operator: CondOperator.EQUALS, value: idClient });
        qb.setFilter({
            field: 'userRole.description',
            operator: CondOperator.EQUALS,
            value: 'Teacher'
        });
        const teachersData = yield manageUsers.find({ queryBuilder: qb });
        if (teachersData)
            setState(prev => (Object.assign(Object.assign({}, prev), { teachers: teachersData, isLoading: false })));
    });
    const { columns, columnsWithoutSort, getTeachersPaginated, renderCellByType, mapDataForCSV, getAllData } = UseManageStudents(getClasses, getUsersPaginated, Styles, manageQuizzesUsers, managePreQuiz);
    const downloadAllData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            const result = yield getAllData();
            if (result && result.length > 0) {
                (_c = document.getElementById('btnDownloadCSV_AllStudents')) === null || _c === void 0 ? void 0 : _c.click();
            }
        }
        catch (error) {
            console.log({
                error
            });
            showCustomError('Error', 'Error downloading data');
        }
    });
    const onSuccessCSV = () => {
        setState(prev => (Object.assign(Object.assign({}, prev), { modalCheckout: true })));
    };
    const handleOnSearch = debounce((event) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { filters: Object.assign(Object.assign({}, prev.filters), { input: event.target.value }) });
        });
    }, 500);
    const handleOnClickManually = () => {
        if (state.isSemiAnnualPlan === 'yes') {
            if (state.students.total < TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL) {
                setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: true })));
            }
            else {
                setState(prev => (Object.assign(Object.assign({}, prev), { modalLimitExceeded: true })));
            }
        }
        else {
            setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: true })));
        }
    };
    /*
    const onValidateStudentsCSV = (studentsForSave: number): boolean => {
      if (state.isSemiAnnualPlan === 'yes') {
        if (state.students.total + studentsForSave < TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL) {
          return true;
        } else {
          setState(prev => ({ ...prev, modalLimitExceeded: true }));
          return false;
        }
      } else {
        return true;
      }
    };
    */
    useEffect(() => {
        if (idClient) {
            getClassList();
            getTeachers();
        }
    }, [idClient, state.reloadClasses]);
    useEffect(() => {
        var _a;
        if ((_a = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription) === null || _a === void 0 ? void 0 : _a.id) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isSemiAnnualPlan: isSemiAnnual(currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription) })));
        }
        // getData();
    }, [(_a = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription) === null || _a === void 0 ? void 0 : _a.id]);
    /*
    const getData = async (): Promise<void> => {
      const current = await Auth.currentSession();
      console.log(current.getIdToken().getJwtToken());
    };
    */
    const openClassModal = () => {
        var _a, _b;
        if (((_a = user === null || user === void 0 ? void 0 : user.client) === null || _a === void 0 ? void 0 : _a.plan) !== PLANS.ANNUAL_INDIVIDUAL && ((_b = user === null || user === void 0 ? void 0 : user.client) === null || _b === void 0 ? void 0 : _b.plan) !== PLANS.SEMI_ANNUAL_INDIVIDUAL) {
            setState(prev => (Object.assign(Object.assign({}, prev), { modalClass: true })));
        }
        else {
            setStateUpload(prev => (Object.assign(Object.assign({}, prev), { openMainModal: true })));
            setState(prev => (Object.assign(Object.assign({}, prev), { idClassCSV: -1 })));
        }
    };
    return (React.createElement(React.Fragment, null,
        toastContainer,
        React.createElement(Container, { className: Styles.mainWrap, fluid: true },
            React.createElement(TabHeader, { icon: React.createElement(IconTeacherBold, null), title: "Manage Students" },
                React.createElement("div", { className: Styles.wrapBtns },
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                        React.createElement(SwitchKvBase, { type: "button", text: "Show Deleted", checked: state.checked, setChecked: (value) => {
                                setState(prev => {
                                    return Object.assign(Object.assign({}, prev), { filters: Object.assign(Object.assign({}, prev.filters), { deleted: value }), checked: value });
                                });
                            } })),
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                        React.createElement(InputSearchBase, { loading: state.isTableLoading, placeholder: "Search...", onChange: handleOnSearch, customStyle: Styles.customStyleSearch })),
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                        React.createElement(SelectFilter, { name: "selectedClassId", state: state, setState: setState, placeholder: 'All Classes', onChange: e => setState(prev => {
                                return Object.assign(Object.assign({}, prev), { filters: Object.assign(Object.assign({}, prev.filters), { selectedClassId: (e === null || e === void 0 ? void 0 : e.value) ? e === null || e === void 0 ? void 0 : e.value : '' }) });
                            }), options: (_b = state.classes) === null || _b === void 0 ? void 0 : _b.map(item => ({
                                value: `${item.key}`,
                                label: `${item.value}`
                            })) })),
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                        React.createElement(SelectFilter, { name: "selectedGradeId", state: state, placeholder: 'All Grades', setState: setState, onChange: e => setState(prev => {
                                return Object.assign(Object.assign({}, prev), { filters: Object.assign(Object.assign({}, prev.filters), { selectedGradeId: (e === null || e === void 0 ? void 0 : e.value) ? e === null || e === void 0 ? void 0 : e.value : '' }) });
                            }), options: state.grades.map(item => ({
                                value: `${item.key}`,
                                label: `${item.value}`
                            })) })),
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 0.2 } },
                        React.createElement(ButtonBorderedKVBase, { type: "button", color: "#00A3FF", onClick: () => setShowExportModal(true), btnWrapClass: Styles.btnExportWrapClass }, "Export"),
                        React.createElement(CSVLink, { id: "btnDownloadCSV_students", style: { display: 'none' }, data: mapDataForCSV(state.students.data), filename: `students_${new Date().getTime()}.csv` }, "Exportar a CSV"),
                        React.createElement(CSVLink, { id: "btnDownloadCSV_AllStudents", style: { display: 'none' }, data: mapDataForCSV(state.allStudents), filename: `students_${new Date().getTime()}.csv` }, "Exportar a CSV")),
                    React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                        React.createElement(BtnDropdown, { title: "Add Students", items: [
                                {
                                    label: 'Add from CSV',
                                    onClick: () => {
                                        openClassModal();
                                    }
                                },
                                {
                                    label: 'Add Manually',
                                    onClick: handleOnClickManually
                                }
                            ] })))),
            React.createElement(Table, { tableHtmlId: "all-table-students", columns: columns, data: state.students.data, dataNotFound: state.dataNotFound, DataNotFoundComponent: () => {
                    return React.createElement(DataNotFoundComp, null);
                }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                    total: state.students.total,
                    page: state.students.page,
                    count: state.students.count,
                    pageCount: state.students.pageCount
                }, fetchData: (pagination, sort) => {
                    getTeachersPaginated(state.filters, pagination, sort);
                }, filters: state.filters, loading: state.isTableLoading })),
        React.createElement(ModalClass, { manageClasses: manageClasses, idClient: idClient }),
        React.createElement(ModalAddStudentsManually, { validationAddStudent: validationAddStudent, idClient: idClient, saveCsvFile: saveCsvFile }),
        React.createElement(ModalUploadStudents, { validation: validationModalUploadTeachers, saveCsvFile: saveCsvFile, idClient: idClient, idClass: state.idClassCSV, onSuccess: onSuccessCSV }),
        state.modalCheckout && React.createElement(ModalCheckout, { manageStripe: manageStripe, idClient: idClient }),
        state.modalLimitExceeded && React.createElement(ModalLimit, null),
        state.modalCheckoutSuccess && React.createElement(ModalCheckoutSuccess, { manageStripe: manageStripe }),
        showExportModal && (React.createElement("div", { className: Styles.modalExportData },
            React.createElement("div", { className: Styles.content },
                React.createElement("h3", null, "Export Data"),
                React.createElement("p", null, "What information would you like to download?"),
                React.createElement("div", { className: Styles.buttons },
                    React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => {
                            setShowExportModal(false);
                            downloadAllData();
                        } }, "Export all data"),
                    React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => {
                            var _a;
                            setShowExportModal(false);
                            (_a = document.getElementById('btnDownloadCSV_students')) === null || _a === void 0 ? void 0 : _a.click();
                        } }, "Export current data")),
                React.createElement("button", { type: "button", className: Styles.cancel, onClick: () => {
                        setShowExportModal(false);
                    } }, "Cancel"))))));
};
const DataNotFoundComp = () => {
    const [state, setState] = useRecoilState(manageStudentsAtom);
    return (React.createElement(TableNotFound, { onClick: () => {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { filters: {
                        input: '',
                        deleted: false
                    }, dataNotFound: false });
            });
        }, term: state.filters.input !== '' ? state.filters.input : null }));
};
export default ManageStudents;
